import * as React from 'react'
import { OfferSection } from '@modules/offers/offer-section'
import { Badge } from '@components/badge'
import { useScrollToOffer } from '@hooks/use-scroll-to-offer'
import { NavigationPath } from '@models/routes'
import { useNavigate } from 'react-router-dom'

const SECTION_ID = 'podwojna-radosc-na-lata-2027-2028'

export const GastroCardPromo20272028Offer = (): React.ReactNode => {
  const { ref } = useScrollToOffer(SECTION_ID)
  const navigate = useNavigate()

  const handleShowDetails = () => {
    navigate(NavigationPath.GastroCardPromo20272028)
  }

  return (
    <div className="container-lg" id={SECTION_ID} ref={ref}>
      <OfferSection
        onImageClick={handleShowDetails}
        badges={
          <div className="d-flex flex-wrap justify-content-center justify-content-sm-start">
            <Badge variant="red" text="Bestseller" className="mb-2 badge-pulsing col-12 col-sm-auto me-0 me-sm-3" />
            <Badge variant="gold" text="Oferta dostępna czasowo" className="mb-2 col-12 col-sm-auto" />
          </div>
        }
        title={
          <span className="font-header">
            Podwójna Radość <br /> na lata 2027/2028
          </span>
        }
        description={
          <span>
            Skorzystaj ze specjalnej promocji{' '}
            <span className="text-nowrap">
              na <strong className="text-nowrap">Voucher Podwójna Radość</strong>
            </span>{' '}
            do wykorzystania <strong>we wszystkich punktach gastronomicznych, włącznie z Restauracją</strong> podczas
            pobytów w latach <span className="text-nowrap">2027-2028</span> w Resortach <br />
            <span className="text-nowrap">Holiday Park & Resort.</span>
          </span>
        }
        onOrderClick={handleShowDetails}
        offerKind="gastro-card-promo-2027-2028"
      />
    </div>
  )
}
